import Participant from "./Participant"

class Gambler extends Participant {

}
export default Gambler
